<template>
  <div class="activity-bumper-wrap">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1920 1080"
      style="enable-background: new 0 0 1920 1080"
      xml:space="preserve"
    >
      <g>
        <g class="fadeIn">
          <defs>
            <rect
              id="SVGID_1_"
              x="-0.5"
              y="10.6"
              width="1921.1"
              height="1058.8"
            />
          </defs>
          <clipPath
            id="SVGID_00000125594972088451663430000003530914816445251760_"
          >
            <use xlink:href="#SVGID_1_" style="overflow: visible" />
          </clipPath>
          <g
            style="
              clip-path: url(#SVGID_00000125594972088451663430000003530914816445251760_);
            "
          >
            <g>
              <defs>
                <rect
                  id="SVGID_00000164483677676229982080000002067576808534974641_"
                  x="197.5"
                  y="387"
                  width="1525.1"
                  height="184.5"
                />
              </defs>
              <clipPath
                id="SVGID_00000129174569500285568720000004141674815114303146_"
              >
                <use
                  xlink:href="#SVGID_00000164483677676229982080000002067576808534974641_"
                  style="overflow: visible"
                />
              </clipPath>
              <g
                style="
                  clip-path: url(#SVGID_00000129174569500285568720000004141674815114303146_);
                "
              >
                <path
                  class="st2"
                  d="M949.8,558.2c-3.6-6.9-8.6-14.5-13.8-22.1l-21.7-32h16.8c9.2,0,15.8-7.6,15.8-16.8v-85.3
                  c0-9.2-5.6-14.8-14.8-14.8H912c-13.2,0-26.7,0-39.9,0c-13.2,0-19.8,12.2-13.2,23.7c2.6,4.3,6.9,5.3,11.5,5.3
                  c14.2,0,28.3,0,42.5,0h0.3v59.9h-27.3c-6.3,0-12.2,3.6-14.8,9.2c-3,5.6-2.6,12.2,1,17.5l38.9,57.6c0.7,1.3,1.6,2.3,2.3,3.6
                  l0.3,0.3c1.3,1.3,2.6,2.6,4.3,3.3c1.6,0.7,3.3,1.3,9.2,1.6c0.3,0,3.3,0,8.6,0c0.3,0,1.3,0,3,0c0.7,0,1.6,0,2,0
                  c2.6,0,5.3,0,7.6-1c1.6-0.7,2.3-1,3-2C952.1,564.5,951.8,561.9,949.8,558.2z"
                />
                <path
                  class="st2"
                  d="M197.5,400.8c0-8.9,5.3-11.9,11.9-11.9h94.5c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9h-72.1
                  v43.8h48.4c8.9,0,11.9,5.3,11.9,11.9v4.6c0,6.6-2.6,11.9-11.9,11.9h-48.4v66.5c0,8.9-5.3,11.9-11.9,11.9h-10.5
                  c-6.6,0-11.9-2.6-11.9-11.9V400.8z"
                />
                <path
                  class="st2"
                  d="M341.5,400.8c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v101.5c0,27,10.9,39.9,35.2,39.9
                  c24,0,37.6-12.8,37.6-39.9V400.8c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v94.9c0,47.4-21.4,75.1-72.8,75.1
                  c-51.4,0-68.8-28-68.8-75.1v-94.9H341.5z"
                />
                <path
                  class="st2"
                  d="M559.2,417.9h-36.6c-8.9,0-11.9-5.3-11.9-11.9v-5.3c0-6.6,2.6-11.9,11.9-11.9h107.7
                  c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9h-36.9v138.3c0,8.9-5.3,11.9-11.9,11.9h-10.9
                  c-6.6,0-11.9-2.6-11.9-11.9V417.9H559.2z"
                />
                <path
                  class="st2"
                  d="M669.5,400.8c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v101.5c0,27,10.9,39.9,35.2,39.9
                  c24,0,37.6-12.8,37.6-39.9V400.8c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v94.9c0,47.4-21.4,75.1-72.8,75.1
                  s-68.8-28-68.8-75.1v-94.9H669.5z"
                />
                <path
                  class="st2"
                  d="M994.6,400.8c0-8.9,5.3-11.9,11.9-11.9h92.2c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9h-69.5
                  v43.8h46.4c8.9,0,11.9,5.3,11.9,11.9v4.6c0,6.6-2.6,11.9-11.9,11.9h-46.4v49.4h72.1c8.9,0,11.9,5.3,11.9,11.9v5.6
                  c0,6.6-2.6,11.9-11.9,11.9h-94.9c-6.6,0-11.9-2.6-11.9-11.9V400.8z"
                />
                <path
                  class="st2"
                  d="M1155,398.5c0-5.3,4.3-9.6,9.6-9.6h4.9c5.3,0,9.5,4.3,9.5,9.6V547h68.5c5.3,0,9.6,3,9.6,8.2v4.6
                  c0,5.3-4.3,8.2-9.6,8.2h-83c-5.3,0-9.6-4.3-9.6-9.6V398.5z"
                />
                <path
                  class="st2"
                  d="M1283.5,558.9l50.4-161.1c1.7-5.3,6.6-8.9,12.2-8.9h14.8c5.6,0,10.5,3.6,12.2,8.9l50.4,160.7
                  c0.3,0.7,0.3,1.3,0.3,2c0,3.6-3,6.9-6.9,6.9h-8.9c-5.6,0-8.2-3.6-9.6-8.9l-13.2-44.5h-64.6l-13.2,44.5
                  c-1.6,5.3-4.6,8.9-9.6,8.9h-7.6c-3.9,0-6.9-3.3-6.9-6.9C1283.2,559.9,1283.2,559.6,1283.5,558.9z M1378.4,493.7l-25.4-85h-0.7
                  l-25.7,85H1378.4z"
                />
                <path
                  class="st2"
                  d="M1448.9,398.5c0-5.3,4.3-9.6,9.5-9.6h41.2c48.4,0,69.5,14.8,69.5,45.5c0,18.4-8.9,31.3-26.7,38.2v0.3
                  c26,8.9,33.6,25.7,33.6,45.1c0,40.2-33.3,49.4-69.8,49.4h-47.4c-5.3,0-9.6-4.3-9.6-9.6V398.5H1448.9z M1500.9,465.7
                  c17.5,0,44.5-2.6,44.5-29.3c0-25-26.7-27-47.4-27h-25.7v56.3H1500.9z M1504.8,547.4c33.3,0,47.4-9.6,47.4-30.6
                  c0-22.4-15.8-32.6-44.5-32.6h-35.6v63.2H1504.8z"
                />
                <path
                  class="st2"
                  d="M1711,461.4h-31.9v-31.9c0-6.3-3.3-9.6-9.6-9.6h-3.6c-6.3,0-9.6,3.3-9.6,9.6v31.9h-31.9
                  c-6.3,0-9.6,3.3-9.6,9.6v3.6c0,6.3,3.3,9.6,9.6,9.6h31.9v32c0,6.3,3.3,9.6,9.6,9.6h3.6c6.3,0,9.6-3.3,9.6-9.6v-32h31.9
                  c6.3,0,9.6-3.3,9.6-9.6V471C1720.9,464.7,1717.3,461.4,1711,461.4z"
                />
                <g>
                  <defs>
                    <rect
                      id="SVGID_00000135657933822671147980000015466663701155735218_"
                      x="197.5"
                      y="387"
                      width="1523.4"
                      height="183.5"
                    />
                  </defs>
                  <clipPath
                    id="SVGID_00000032622746537098916430000002029078182669905796_"
                  >
                    <use
                      xlink:href="#SVGID_00000135657933822671147980000015466663701155735218_"
                      style="overflow: visible"
                    />
                  </clipPath>
                  <g
                    style="
                      clip-path: url(#SVGID_00000032622746537098916430000002029078182669905796_);
                    "
                  >
                    <path
                      class="st4"
                      d="M949.8,557.9c-3.6-6.9-8.6-14.5-13.8-22.1l-21.7-32h16.8c9.2,0,15.8-7.6,15.8-16.8v-85.3
                      c0-9.2-5.6-14.8-14.8-14.8H912c-13.2,0-26.7,0-39.9,0c-13.2,0-19.8,12.2-13.2,23.7c2.6,4.3,6.9,5.3,11.5,5.3
                      c14.2,0,28.3,0,42.5,0h0.3v59.9h-27.3c-6.3,0-12.2,3.6-14.8,9.2c-3,5.6-2.6,12.2,1,17.5l38.9,57.6c0.7,1.3,1.6,2.3,2.3,3.6
                      l0.3,0.3c1.3,1.3,2.6,2.6,4.3,3.3c1.6,0.7,3.3,1.3,9.2,1.6c0.3,0,3.3,0,8.6,0c0.3,0,1.3,0,3,0c0.7,0,1.6,0,2,0
                      c2.6,0,5.3,0,7.6-1c1.6-0.7,2.3-1,3-2C952.1,564.2,951.8,561.6,949.8,557.9z"
                    />
                    <path
                      class="st4"
                      d="M197.5,400.5c0-8.9,5.3-11.9,11.9-11.9h94.5c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9
                      h-72.1v43.8h48.4c8.9,0,11.9,5.3,11.9,11.9v4.6c0,6.6-2.6,11.9-11.9,11.9h-48.4v66.5c0,8.9-5.3,11.9-11.9,11.9h-10.5
                      c-6.6,0-11.9-2.6-11.9-11.9V400.5z"
                    />
                    <path
                      class="st4"
                      d="M341.5,400.5c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v101.5c0,27,10.9,39.9,35.2,39.9
                      c24,0,37.6-12.8,37.6-39.9V400.5c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v94.9c0,47.4-21.4,75.1-72.8,75.1
                      c-51.4,0-68.8-28-68.8-75.1v-94.9H341.5z"
                    />
                    <path
                      class="st4"
                      d="M559.2,417.6h-36.6c-8.9,0-11.9-5.3-11.9-11.9v-5.3c0-6.6,2.6-11.9,11.9-11.9h107.7
                      c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9h-36.9v138.3c0,8.9-5.3,11.9-11.9,11.9h-10.9
                      c-6.6,0-11.9-2.6-11.9-11.9V417.6H559.2z"
                    />
                    <path
                      class="st4"
                      d="M669.5,400.5c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v101.5c0,27,10.9,39.9,35.2,39.9
                      c24,0,37.6-12.8,37.6-39.9V400.5c0-8.9,5.3-11.9,11.9-11.9h10.9c6.6,0,11.9,2.6,11.9,11.9v94.9c0,47.4-21.4,75.1-72.8,75.1
                      s-68.8-28-68.8-75.1v-94.9H669.5z"
                    />
                    <path
                      class="st4"
                      d="M994.6,400.5c0-8.9,5.3-11.9,11.9-11.9h92.2c8.9,0,11.9,5.3,11.9,11.9v5.6c0,6.6-2.6,11.9-11.9,11.9
                      h-69.5v43.8h46.4c8.9,0,11.9,5.3,11.9,11.9v4.6c0,6.6-2.6,11.9-11.9,11.9h-46.4v49.4h72.1c8.9,0,11.9,5.3,11.9,11.9v5.6
                      c0,6.6-2.6,11.9-11.9,11.9h-94.9c-6.6,0-11.9-2.6-11.9-11.9V400.5z"
                    />
                    <path
                      class="st4"
                      d="M1155,398.2c0-5.3,4.3-9.6,9.6-9.6h4.9c5.3,0,9.5,4.3,9.5,9.6v148.6h68.5c5.3,0,9.6,3,9.6,8.2v4.6
                      c0,5.3-4.3,8.2-9.6,8.2h-83c-5.3,0-9.6-4.3-9.6-9.6V398.2z"
                    />
                    <path
                      class="st4"
                      d="M1283.5,558.6l50.4-161.1c1.7-5.3,6.6-8.9,12.2-8.9h14.8c5.6,0,10.5,3.6,12.2,8.9l50.4,160.7
                      c0.3,0.7,0.3,1.3,0.3,2c0,3.6-3,6.9-6.9,6.9h-8.9c-5.6,0-8.2-3.6-9.6-8.9l-13.2-44.5h-64.6l-13.2,44.5
                      c-1.6,5.3-4.6,8.9-9.6,8.9h-7.6c-3.9,0-6.9-3.3-6.9-6.9C1283.2,559.6,1283.2,559.2,1283.5,558.6z M1378.4,493.4l-25.4-85
                      h-0.7l-25.7,85H1378.4z"
                    />
                    <path
                      class="st4"
                      d="M1448.9,398.2c0-5.3,4.3-9.6,9.5-9.6h41.2c48.4,0,69.5,14.8,69.5,45.5c0,18.4-8.9,31.3-26.7,38.2v0.3
                      c26,8.9,33.6,25.7,33.6,45.1c0,40.2-33.3,49.4-69.8,49.4h-47.4c-5.3,0-9.6-4.3-9.6-9.6V398.2H1448.9z M1500.9,465.4
                      c17.5,0,44.5-2.6,44.5-29.3c0-25-26.7-27-47.4-27h-25.7v56.3H1500.9z M1504.8,547.1c33.3,0,47.4-9.6,47.4-30.6
                      c0-22.4-15.8-32.6-44.5-32.6h-35.6v63.2H1504.8z"
                    />
                    <path
                      class="st2"
                      d="M1711,461.1h-31.9v-31.9c0-6.3-3.3-9.6-9.6-9.6h-3.6c-6.3,0-9.6,3.3-9.6,9.6v31.9h-31.9
                      c-6.3,0-9.6,3.3-9.6,9.6v3.6c0,6.3,3.3,9.6,9.6,9.6h31.9v32c0,6.3,3.3,9.6,9.6,9.6h3.6c6.3,0,9.6-3.3,9.6-9.6v-32h31.9
                      c6.3,0,9.6-3.3,9.6-9.6v-3.6C1720.9,464.4,1717.3,461.1,1711,461.1z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g class="fadeInUp">
          <rect y="926" class="st5" width="1920.1" height="154.1" />
          <path
            class="st6"
            d="M235.3,973.2V968c0,0,1-7.7-11.9-7.7c-12.9,0-12.5,7.7-12.5,7.7v25.4c0,0-0.8,7.3,12.5,7.3
          c11.3,0,11.9-3.3,11.9-3.3v-11.2h-11.9v-6.8h25.3v18.1c0,0-5.1,10.1-25.3,10.1c-23.8,0-25.9-14-25.9-14V968c0,0,1.2-14,25.9-14
          c26.7,0,25.3,14,25.3,14v5.1L235.3,973.2z M490.1,980c0,0,0.9-10.2-19.6-10.2c-20.5,0-19.5,10.1-19.5,10.1v17.5
          c0,0-0.9,10.1,19.5,10.1c20.5,0,19.6-10.1,19.6-10.1v-2.8h-10.8v2.8c0,0,0,4.4-8.8,4.4c-8.8,0-8.8-4.3-8.8-4.3s0-6.4,0-6.4H490
          L490.1,980z M470.4,975.7c8.9,0,8.9,4.5,8.9,4.5v3.9h-17.5v-3.9C461.8,980.2,461.7,975.7,470.4,975.7z M533,984.8V980
          c0,0,0.9-10.2-19.6-10.2c-20.5,0-19.6,10.1-19.6,10.1v17.5c0,0-0.9,10.1,19.6,10.1c20.5,0,19.6-10.1,19.6-10.1v-4.3h-10.8v4.4
          c0,0,0,4.4-8.8,4.4c-8.8,0-8.7-4.4-8.8-4.4c-0.1,0,0-17.4,0-17.4s0-4.5,9.2-4.5c9.2,0,8.4,4.4,8.4,4.4v4.6L533,984.8z M422.7,976.9
          h3.5V998c0,9.4,12.8,10.3,22.1,9.1v-5.3c-10.7,1.5-11.3-3.9-11.3-3.9v-21.1h11.8v-5.8h-11.9v-8.3h-10.8v8.3h-3.5L422.7,976.9z
           M377.4,980c0,0,0.9-10.2-19.6-10.2c-20.6,0-19.5,10.1-19.5,10.1v17.5c0,0-0.9,10.1,19.5,10.1c20.4,0,19.6-10.1,19.6-10.1v-2.8
          h-10.8v2.8c0,0,0,4.4-8.9,4.4c-8.9,0-8.7-4.3-8.8-4.3c0,0,0-6.4,0-6.4h28.4V980z M357.8,975.7c8.9,0,8.9,4.5,8.9,4.5v3.9h-17.5
          v-3.9C349.1,980.2,349,975.7,357.8,975.7z M291.7,980c0,0,0.9-10.2-19.6-10.2s-19.6,10.1-19.6,10.1v17.5c0,0-0.9,10.1,19.6,10.1
          s19.6-10.1,19.6-10.1v-2.8H281v2.8c0,0,0,4.4-8.8,4.4s-8.8-4.3-8.8-4.3s0-6.4,0-6.4h28.4L291.7,980z M272.1,975.7
          c8.9,0,8.9,4.5,8.9,4.5v3.9h-17.5v-3.9C263.4,980.2,263.3,975.7,272.1,975.7z M537.3,1006.1h10.8v-26.6c0,0,0-4.4,8.8-4.4
          c8.8,0,8.9,4.3,8.9,4.3v26.7h10.8v-27.8c0,0-0.5-9.1-19.6-9.1c-2.9,0-5.9,0.2-8.8,0.8c0,0,0-15.8,0-15.8c0,0.1-10.8,0-10.8,0
          V1006.1z M315,969.2c-4.7-0.2-9.5,0.6-13.8,2.5h-5.8v34.4h10.9v-26.6c0,0,0-4.5,8.7-4.5c8.7,0,8.9,4.4,8.9,4.4v26.7h10.8v-27.8
          C334.6,978.3,334.1,969.2,315,969.2z M400.6,969.2c-4.7-0.2-9.5,0.6-13.8,2.5H381v34.4h10.8v-26.6c0,0,0-4.4,8.8-4.4
          c8.8,0,8.8,4.3,8.8,4.3v26.7h10.8v-27.8C420.2,978.3,419.8,969.2,400.6,969.2z"
          />
          <path
            class="st6"
            d="M214.1,1025l1,5.4c0.6,3.5,1.2,7.4,1.8,10.9c0.4,2.4,0.8,2.6,2.6,2.7l-0.2,1h-7.7v-0.8h1.1c1,0,1.2-0.4,1-1.7
          l-0.5-4.5h-5.6c-0.5,0.8-1.3,2.6-2,3.9c-0.7,1.3-0.7,1.9,0.5,2h1l-0.2,0.8H200l0.2-0.8c1.8-0.2,2.2-0.5,3.8-3.1l8.9-15.6
          L214.1,1025z M208,1036.7h4.8l-1.1-6.8L208,1036.7z M238.6,1025.4l3.8,14.5l9-14.5h5.8v0.8c-2.4,0.2-2.6,0.4-3.2,3.5l-1.6,10.5
          c-0.5,3.3-0.4,3.5,2,3.5l-0.2,0.8h-8.6l0.2-0.8c2.3-0.2,2.5-0.4,3.1-3.5l2-11.7l-9.6,15.8h-0.9l-3.7-15.2l-1.8,7.8
          c-0.4,1.8-0.8,3.6-1,5.4c0,1.1,0.5,1.4,2.5,1.5l-0.3,1.2h-7v-0.9c1.5,0,2.2-0.4,2.7-1.5c0.6-1.8,1.2-3.7,1.6-5.6l1.6-6.6
          c0.9-3.5,0.6-3.9-1.9-4.1l0.2-0.8L238.6,1025.4z M266.9,1041.9c-0.9,1-1.9,1.9-3.1,2.5c-1.2,0.6-2.5,1-3.9,1
          c-1.4,0-3.5-0.9-3.5-4.4c0-1.4,0.3-2.9,0.9-4.2c0.6-1.3,1.5-2.5,2.6-3.4c1.4-1.1,3.1-1.7,4.8-1.9c1.9,0,2.9,1.1,2.9,2.4
          c0,2.7-5.2,4.7-8,5.6c0,0.2,0,0.4,0,0.6c0,1.4,0.4,3.2,2.2,3.2c1.7-0.2,3.3-0.9,4.5-2.2L266.9,1041.9z M262.5,1033.2
          c-0.8,0.6-1.4,1.4-1.9,2.4s-0.7,1.9-0.7,2.9c3.5-1.2,4.9-2.5,4.9-4.2c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.5
          c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1C263.2,1032.9,262.8,1033,262.5,1033.2z M269.6,1034.7c1.4-1.5,3.2-2.6,5.2-3.1
          c1,0,1,1.1,0.6,2.7l-0.5,2.2c1.5-1.9,3.3-3.4,5.4-4.5c0.5-0.3,1-0.4,1.6-0.5c0.6,0,1.7,0.4,0.9,3.5l-0.4,1.5
          c1.5-1.9,3.3-3.4,5.4-4.5c0.5-0.3,1-0.4,1.6-0.5c0.6,0,1.8,0.4,1.1,3.8c-0.4,1.6-1.1,4.1-1.6,6.6c0,0.8-0.3,1.1,0,1.1
          c0.8-0.3,1.5-0.7,2.1-1.3l0.4,0.8c-1.4,1.3-3.1,2.3-4.9,2.8c-0.9,0-1.3-0.7-0.8-2.5l1.7-7c0.3-1.3,0.4-2-0.3-2s-4,2.9-5.2,5.1
          c-0.5,1.9-0.9,3.8-1.2,5.7l-3.2,0.8c0.4-1.6,0.8-3.3,1.2-4.9l1.2-5c0-0.8,0.2-1.6-0.4-1.6c-0.6,0-4,2.9-5.2,5.1
          c-0.5,1.9-0.9,3.8-1.2,5.7l-3.3,0.8c0.5-1.6,0.8-3.3,1.2-4.9l1.1-4.9c0.2-1.1,0.3-1.5,0-1.5c-0.8,0.3-1.5,0.8-2.1,1.4L269.6,1034.7
          z M294.9,1024.9c2.5-0.5,5.2-1.3,5.4-1.3c0.2,0,0.4,0.5,0.2,1.4l-2.4,10.5c1.6-2,3.9-3.4,6.5-3.9c1.2,0,2,1,2,2.8
          c0,1.8-0.4,3.6-1.2,5.2c-0.8,1.6-1.9,3.1-3.3,4.2c-1.4,1-3.1,1.6-4.8,1.6c-0.7,0.1-1.4,0-2-0.3c-0.6-0.3-1.1-0.8-1.5-1.4
          c-0.2-1.1-0.1-2.1,0.2-3.2l2.7-13.6c0.2-1.2,0.2-1.3-0.8-1.3h-1.4L294.9,1024.9z M299,1036.2c-1.1,1.3-1.2,1.8-1.6,4.4
          c-0.4,2.6,0.2,3.5,1.5,3.5c0.5,0,1-0.1,1.5-0.4c1.1-1.1,1.9-2.3,2.5-3.7c0.6-1.4,0.8-2.9,0.8-4.3c0-1.5-0.4-2-1-2
          C301.9,1033.6,300,1034.9,299,1036.2z M319.2,1041.9c-0.9,1-1.9,1.9-3.1,2.5c-1.2,0.6-2.5,1-3.9,1c-1.4,0-3.5-0.9-3.5-4.4
          c0-1.4,0.3-2.9,0.9-4.2c0.6-1.3,1.5-2.5,2.6-3.4c1.4-1.1,3.1-1.7,4.8-1.9c1.9,0,2.9,1.1,2.9,2.4c0,2.7-5.2,4.7-8,5.6
          c0,0.2,0,0.4,0,0.6c0,1.4,0.4,3.2,2.2,3.2c1.7-0.2,3.3-0.9,4.5-2.2L319.2,1041.9z M314.9,1033.2c-0.8,0.6-1.4,1.4-1.9,2.4
          c-0.5,0.9-0.7,1.9-0.7,2.9c3.5-1.2,4.9-2.5,4.9-4.2c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.5c-0.1-0.1-0.3-0.2-0.4-0.3
          c-0.2-0.1-0.3-0.1-0.5-0.1C315.5,1032.9,315.2,1033,314.9,1033.2z M321.7,1034.7c1.3-1.5,3-2.5,4.9-3.1c0.8,0,0.8,1.1,0.6,2.1
          l-0.5,2.3c1.4-2.6,3.2-4.4,4-4.4c0.3,0,0.6,0,0.9,0.2c0.3,0.1,0.5,0.4,0.7,0.6c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2-0.1,0.5-0.2,0.7
          c-0.2,0.4-0.5,0.7-0.9,1c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2c-0.3-0.2-0.6-0.3-1-0.4c-0.3,0-0.7,0-1.4,1
          c-0.7,0.9-1.3,2-1.7,3.2c-0.5,2-0.8,4-1.1,6l-3.2,0.9c0.4-1.6,0.7-3.2,1.1-4.9l1-4.8c0.2-1.3,0.3-1.6,0-1.6
          c-0.8,0.3-1.5,0.8-2.1,1.4L321.7,1034.7z M351.2,1035.9c0,1.4-0.3,2.8-0.9,4c-0.5,1.3-1.3,2.4-2.3,3.4c-1.4,1.2-3.1,1.9-4.9,2
          c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1-0.6-1.5-1c-0.4-0.4-0.7-1-0.9-1.5c-0.2-0.6-0.2-1.2-0.2-1.8c0-1.6,0.3-3.2,1.1-4.6
          c0.8-1.4,1.9-2.6,3.2-3.4c1.1-0.7,2.4-1.1,3.8-1.1c0.6,0,1.1,0,1.7,0.3c0.5,0.2,1,0.5,1.4,0.9s0.7,0.9,0.9,1.4
          C351.2,1034.7,351.3,1035.3,351.2,1035.9z M344.9,1033c-1.1,0.9-1.9,2-2.4,3.2c-0.5,1.3-0.7,2.6-0.5,4c0,2.3,0.8,3.8,2.2,3.8
          c0.2,0,0.5,0,0.7,0c1.1-1,1.9-2.2,2.4-3.6c0.5-1.4,0.7-2.8,0.5-4.2c0-2.2-0.8-3.3-2-3.3C345.5,1032.9,345.2,1032.9,344.9,1033z
           M362.7,1032.3l-0.7,0.9l-3.1,0.3c-0.4,2.6-0.7,4.5-1.2,6.7c-0.4,3.7-1.7,7.2-3.9,10.1c-0.9,1.1-2.1,1.8-3.5,2
          c-0.6,0-1.3-0.3-1.3-1c0-0.5,0.2-1,0.6-1.3c0.1-0.1,0.3-0.2,0.4-0.3c0.2,0,0.3,0,0.5,0c0.4,0.2,0.9,0.4,1.4,0.5
          c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.1,0.3-0.3c1-2.5,1.6-5.1,1.8-7.8c0.6-3.8,0.9-6.1,1.3-8.7h-2.4v-0.3l0.9-0.9h1.8
          c0.3-2.3,1.3-4.4,2.8-6.1c0.6-0.8,1.4-1.4,2.3-1.8c0.9-0.4,1.8-0.7,2.8-0.7c1.2,0,2,0.6,2,1.3c0,0.3-0.1,0.5-0.2,0.8
          c-0.1,0.2-0.3,0.4-0.5,0.6c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.6-0.6-1.3-1-2.2-1.1c-0.8,0-1.5,1.3-2.4,7L362.7,1032.3z
           M378.2,1028.3l-1,4h3.7l-1,1.1h-3l-1.7,7.9c-0.2,1.2,0,1.6,0,1.6s2-1.2,2.7-1.9l0.5,0.6c-1.4,1.7-3.3,2.9-5.4,3.5
          c-0.9,0-1.6-1.1-1-3.9l1.7-8h-2.3l-0.2-0.4l0.9-0.9h1.9l0.5-2.2l3-2.1L378.2,1028.3z M380.8,1045.4l0.9-4.6l2.7-14
          c0.2-1.2,0.2-1.3-0.8-1.3h-1.4v-0.7c2.5-0.5,5.2-1.3,5.5-1.3c0.2,0,0.4,0.5,0.2,1.4l-2.4,11.4c1.5-1.8,3.3-3.3,5.4-4.4
          c0.5-0.3,1.1-0.4,1.7-0.5c0.7,0,1.8,0.4,1.2,3.1c-0.6,2.8-1.1,4.8-1.6,7.3c0,0.8-0.2,1.1,0,1.1c0.8-0.3,1.5-0.7,2.1-1.3l0.4,0.8
          c-1.4,1.3-3.1,2.3-4.9,2.8c-0.8,0-1.2-0.7-0.8-2.5l1.6-7c0.3-1.3,0.4-2-0.3-2s-4,2.8-5.2,4.9c-0.2,0.9-0.9,4.2-1.1,5.9
          L380.8,1045.4z M407.2,1041.8c-0.9,1-1.9,1.9-3.1,2.5c-1.2,0.6-2.5,1-3.9,1c-1.4,0-3.5-0.9-3.5-4.4c0-1.4,0.3-2.9,0.9-4.2
          c0.6-1.3,1.5-2.5,2.6-3.4c1.4-1.1,3.1-1.7,4.8-1.9c1.9,0,2.9,1.1,2.9,2.4c0,2.7-5.2,4.7-8,5.6c0,0.2,0,0.4,0,0.6
          c0,1.4,0.4,3.2,2.2,3.2c1.7-0.2,3.3-0.9,4.5-2.2L407.2,1041.8z M402.9,1033.1c-0.8,0.6-1.5,1.4-1.9,2.4c-0.5,0.9-0.7,1.9-0.7,2.9
          c3.5-1.2,4.9-2.5,4.9-4.2c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1
          c-0.3,0.1-0.6,0.2-0.8,0.4L402.9,1033.1z M427.2,1025.4c3.2,0,6.5,0.8,6.5,4.8c-0.1,1.3-0.7,2.6-1.6,3.6c-0.9,1-2.1,1.7-3.4,1.9
          c0.5,1.4,1.1,2.7,1.8,4.1c0.6,1.2,1.2,2.4,1.9,3.5c0.2,0.4,0.5,0.7,0.9,0.9c0.4,0.2,0.8,0.4,1.2,0.5l-0.2,0.7h-0.9
          c-3.3,0-4.1-1.1-5.1-2.8c-0.9-1.8-1.5-3.5-2.1-4.8c-0.4-0.9-0.6-1.1-1.5-1.1h-1.2l-0.8,4c-0.6,3.3-0.4,3.5,2,3.5v0.8h-8.4v-0.8
          c2.4-0.2,2.6-0.4,3.2-3.5l2-10.5c0.6-3.2,0.4-3.5-1.9-3.5v-0.8L427.2,1025.4z M423.7,1035.4h1.2c0.7,0,1.5-0.1,2.1-0.4
          c0.7-0.3,1.3-0.7,1.8-1.2c0.5-0.5,0.9-1.1,1.2-1.8c0.3-0.7,0.4-1.4,0.4-2.1c0.1-0.5,0-1-0.1-1.4c-0.2-0.5-0.4-0.9-0.7-1.2
          c-0.3-0.3-0.8-0.6-1.2-0.7c-0.5-0.2-0.9-0.2-1.4-0.1c-0.5-0.1-1-0.1-1.4,0c-0.2,0-0.3,0.4-0.4,0.9L423.7,1035.4z M448.9,1035.8
          c0,1.4-0.3,2.8-0.8,4c-0.5,1.3-1.4,2.4-2.4,3.4c-1.3,1.2-3,1.9-4.8,2c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1-0.6-1.5-1
          c-0.4-0.4-0.7-1-0.9-1.5c-0.2-0.6-0.2-1.2-0.2-1.8c0-1.6,0.3-3.2,1.1-4.6c0.8-1.4,1.9-2.6,3.2-3.4c1.1-0.7,2.4-1.1,3.8-1.1
          c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.5,1.4,1c0.4,0.4,0.7,0.9,0.9,1.5C448.8,1034.7,448.9,1035.3,448.9,1035.8L448.9,1035.8z
           M442.7,1033c-1.1,0.9-1.9,2-2.4,3.2c-0.5,1.3-0.7,2.6-0.5,4c0,2.3,0.8,3.8,2.2,3.8c0.2,0,0.5,0,0.7,0c1-1,1.8-2.2,2.4-3.6
          c0.5-1.3,0.7-2.8,0.6-4.2c0-2.2-0.8-3.3-2-3.3C443.3,1032.9,443,1032.9,442.7,1033L442.7,1033z M460.7,1042.2
          c-1.6,1.7-3.8,2.9-6.1,3.2c-2.3,0-3.5-1.5-3.5-4.3c0-1.4,0.3-2.7,0.9-4c0.6-1.3,1.4-2.4,2.3-3.3c1.4-1.3,3.3-2.1,5.2-2.2
          c1.3,0,2.5,0.7,2.5,1.6c0,0.3-0.1,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.6,0.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1
          c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.2-0.8-0.4-1.2-0.4c-0.6,0-1.3,0.5-2,1.6
          c-0.9,1.7-1.4,3.7-1.4,5.6c0,1.9,0.6,3,2,3c1.4-0.2,2.8-0.8,3.9-1.7L460.7,1042.2z M462.8,1045.4l0.9-4.6l2.7-14
          c0.2-1.2,0.2-1.3-0.8-1.3h-1.4v-0.7c2.5-0.5,5.2-1.3,5.5-1.3c0.2,0,0.4,0.5,0.2,1.4l-2.4,11.4c1.5-1.8,3.3-3.3,5.4-4.4
          c0.5-0.3,1.1-0.4,1.6-0.5c0.7,0,1.8,0.4,1.2,3.1s-1.1,4.8-1.6,7.3c0,0.8-0.2,1.1,0,1.1c0.8-0.3,1.5-0.7,2.1-1.3l0.4,0.8
          c-1.4,1.3-3.1,2.3-4.9,2.8c-0.8,0-1.2-0.7-0.8-2.5l1.6-7c0.3-1.3,0.4-2-0.3-2s-4,2.8-5.2,4.9c0,0.9-0.9,4.2-1.1,5.9L462.8,1045.4z
           M489.2,1041.8c-0.9,1-1.9,1.9-3.1,2.5c-1.2,0.6-2.5,1-3.9,1c-1.4,0-3.5-0.9-3.5-4.4c0-1.4,0.3-2.9,0.9-4.2
          c0.6-1.3,1.5-2.5,2.6-3.4c1.4-1.1,3.1-1.7,4.8-1.9c1.9,0,2.9,1.1,2.9,2.4c0,2.7-5.1,4.7-8,5.6c0,0.2,0,0.4,0,0.6
          c0,1.4,0.4,3.2,2.2,3.2c1.7-0.2,3.3-0.9,4.5-2.2L489.2,1041.8z M484.9,1033.1c-0.8,0.6-1.5,1.4-1.9,2.4c-0.5,0.9-0.7,1.9-0.7,2.9
          c3.5-1.2,4.9-2.5,4.9-4.2c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1
          C485.5,1032.9,485.1,1033,484.9,1033.1L484.9,1033.1z M517,1030.6c0.1-0.6,0-1.3-0.3-1.9c-0.2-0.6-0.6-1.1-1.1-1.6s-1-0.8-1.6-0.9
          c-0.6-0.2-1.3-0.2-1.9-0.1c-5.4,0-8.8,4.9-8.8,10.5c0,4.5,2,7.5,6.2,7.5c1.3,0,2.6-0.4,2.8-1.7l0.6-3.2c0.4-2.1,0.3-2.1-2.9-2.4
          v-0.9h8.3v0.9c-1.5,0-1.8,0-2.2,2.4l-0.5,2.7c-0.1,0.7-0.2,1.4-0.2,2.2c-2.1,0.7-4.3,1.1-6.5,1.2c-1.2,0.1-2.4,0-3.6-0.4
          c-1.1-0.4-2.2-1-3.1-1.8c-0.9-0.8-1.6-1.8-2-3c-0.4-1.1-0.6-2.3-0.6-3.5c0.1-1.7,0.4-3.3,1.1-4.8s1.7-2.8,2.9-4
          c1.2-1.1,2.7-1.9,4.3-2.5c1.6-0.5,3.2-0.7,4.9-0.6c1.8,0,3.6,0.3,5.3,0.8c0,1-0.2,2.6-0.4,4.8L517,1030.6z M519.6,1034.6
          c1.3-1.5,3-2.5,4.9-3.1c0.8,0,0.8,1.1,0.6,2.1l-0.5,2.3c1.4-2.6,3.2-4.4,4-4.4c0.3,0,0.6,0,0.9,0.2c0.3,0.1,0.5,0.4,0.7,0.6
          c0.1,0.2,0.2,0.5,0.2,0.7c0,0.2-0.1,0.5-0.2,0.7c-0.2,0.4-0.5,0.7-0.9,1c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2
          c-0.3-0.2-0.6-0.3-1-0.4c-0.3,0-0.7,0-1.4,1c-0.7,0.9-1.3,2-1.6,3.2c-0.5,2-0.8,4-1.1,6l-3.2,0.9c0.4-1.6,0.7-3.2,1.1-4.9l1-4.8
          c0.2-1.3,0.2-1.6,0-1.6c-0.8,0.3-1.5,0.8-2.1,1.4L519.6,1034.6z M543,1035.8c0,1.4-0.3,2.8-0.9,4c-0.5,1.3-1.3,2.4-2.3,3.4
          c-1.3,1.2-3,1.9-4.8,2c-0.6,0-1.2-0.1-1.7-0.4s-1-0.6-1.4-1c-0.4-0.4-0.7-1-0.9-1.5c-0.2-0.6-0.2-1.1-0.2-1.7
          c-0.1-1.6,0.3-3.2,1.1-4.6c0.8-1.4,1.9-2.6,3.2-3.4c1.1-0.7,2.5-1.1,3.8-1.1c0.6,0,1.1,0.1,1.6,0.3c0.5,0.2,1,0.5,1.4,0.9
          c0.4,0.4,0.7,0.9,0.9,1.4C543,1034.8,543,1035.3,543,1035.8L543,1035.8z M536.9,1033c-0.9,0.4-2.9,2.7-2.9,7.2
          c0,2.3,0.8,3.8,2.2,3.8c0.2,0,0.5,0,0.7,0c1-1,1.8-2.2,2.3-3.6c0.5-1.3,0.7-2.8,0.5-4.2c0-2.2-0.8-3.3-2-3.3
          C537.5,1032.9,537.1,1032.9,536.9,1033L536.9,1033z M545.4,1034.6c1.4-1.5,3.2-2.6,5.2-3.1c0.7,0,1,0.7,0.7,2.2l-1.6,7
          c-0.3,1.5-0.3,2.3,0.3,2.3c0.6,0,1.5-0.9,2.6-2.2c1-1.2,1.9-2.4,2.7-3.8c0-0.7,0.7-3.2,1-4.8l2.8-0.8h0.4c-0.7,3.5-1.5,7-2.2,10.5
          c-0.2,0.8-0.2,1.1,0,1.1c0.8-0.3,1.5-0.7,2.1-1.3l0.4,0.8c-1.4,1.3-3,2.3-4.8,2.8c-0.9,0-1.2-0.9-0.8-2.6l0.7-3
          c-1.2,1.9-2.9,3.6-4.8,4.8c-0.7,0.5-1.5,0.7-2.3,0.8c-0.6,0-1.9-0.4-1.1-3.8l1.3-6c0.2-1.1,0.4-1.5,0-1.5c-0.8,0.3-1.5,0.8-2.2,1.4
          L545.4,1034.6z M568,1031.9c0.8-0.3,1.7-0.4,2.6-0.4c3.5,0,4.8,1.6,4.8,4.1c-0.1,2.3-1.1,4.6-2.7,6.3c-1.5,1.7-3.5,3-5.8,3.5
          c-0.5,0-1.1-0.1-1.6-0.2l-0.7,3.9c-0.3,1.4-0.2,1.8,0.8,1.9h1.5v0.8l-7.9,0.5v-0.8c2-0.3,2.2-0.5,2.5-2l3.1-15.5
          c-0.8,0.2-1.6,0.4-2.4,0.7l-0.2-0.9c1-0.5,2-0.9,3-1.2l0.3-1.2c0.9-0.8,1.8-1.5,2.9-2l0.3,0.2L568,1031.9z M565.7,1043.1
          c0.2,0.3,0.4,0.5,0.7,0.6c0.3,0.1,0.6,0.2,0.9,0.2c2,0,4.7-3.8,4.7-7.7c0-2.5-1.5-3.2-2.7-3.2c-0.5,0-1.1,0.1-1.6,0.2L565.7,1043.1
          z"
          />
          <path
            class="st6"
            d="M1062.1,967h-6.7v25.3h6.7c8,0,12.1-4.5,12.1-12.7C1074.3,971.5,1070.2,967,1062.1,967z M1062.4,988.6h-2.2
          v-17.8h2.2c4.4,0,6.8,3.2,6.8,8.9C1069.2,985.4,1066.9,988.6,1062.4,988.6z M1093.9,982.5c0-4.7-2.6-8.5-8.1-8.5
          c-5.6,0-8.2,4-8.2,9.4c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6c-2.4,0-3.9-1.8-3.9-4.8h11.8
          C1093.9,984.1,1093.9,983.8,1093.9,982.5z M1085.8,977.3c2.3,0,3.5,1.5,3.6,4.1h-7.3C1082.2,978.7,1083.7,977.3,1085.8,977.3z
           M1108.9,974.6l-4.6,12.8l-4.5-12.8h-5l6.8,17.8h4.5l6.8-17.8H1108.9z M1130.4,982.5c0-4.7-2.6-8.5-8.1-8.5c-5.6,0-8.2,4-8.2,9.4
          c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6c-2.4,0-3.9-1.8-3.9-4.8h11.8
          C1130.3,984.1,1130.4,983.8,1130.4,982.5z M1122.2,977.3c2.3,0,3.5,1.5,3.6,4.1h-7.3C1118.7,978.7,1120.2,977.3,1122.2,977.3z
           M1134.5,992.4h4.6v-26.1h-4.6V992.4z M1152.1,992.9c5.3,0,8.8-3.5,8.8-9.5c0-5.9-3.5-9.4-8.8-9.4c-5.2,0-8.8,3.5-8.8,9.4
          C1143.3,989.4,1146.9,992.9,1152.1,992.9z M1152.1,989.3c-2.5,0-3.9-2.1-3.9-5.9c0-3.7,1.4-5.8,3.9-5.8c2.5,0,3.9,2.1,3.9,5.8
          C1156,987.2,1154.6,989.3,1152.1,989.3z M1174.6,974c-2.1,0-3.9,0.9-5,2.5v-2h-4.4v24h4.6V991c1.1,1.3,2.7,1.9,4.6,1.9
          c4.7,0,7.5-3.5,7.5-9.5C1181.8,977.5,1179.2,974,1174.6,974z M1173.2,989c-1.6,0-2.8-0.8-3.5-2.6v-5.9c0.7-1.8,1.9-2.6,3.5-2.6
          c2.4,0,3.7,1.9,3.7,5.5C1177,987,1175.7,989,1173.2,989z M1201,982.5c0-4.7-2.6-8.5-8.1-8.5c-5.6,0-8.2,4-8.2,9.4
          c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6c-2.4,0-3.9-1.8-3.9-4.8h11.8
          C1201,984.1,1201,983.8,1201,982.5z M1192.9,977.3c2.3,0,3.5,1.5,3.6,4.1h-7.3C1189.4,978.7,1190.8,977.3,1192.9,977.3z
           M1216.1,966.3v10c-0.9-1.4-2.8-2.3-5-2.3c-4.7,0-7.4,3.4-7.4,9.4c0,6,2.8,9.5,7.7,9.5c2.3,0,4.1-0.9,5.2-2.6l0.5,2h3.6v-26.1
          H1216.1z M1212.4,989c-2.5,0-3.8-2-3.8-5.6c0-3.5,1.3-5.5,3.8-5.5c1.8,0,3,0.8,3.8,2.5v6C1215.4,988.2,1214.2,989,1212.4,989z
           M1234.8,971.2h5v-4.8h-5V971.2z M1234.9,992.4h4.6v-17.8h-4.6V992.4z M1254.8,974c-2.4,0-4.3,1-5.2,2.7v-2.2h-4.5v17.8h4.6v-12.1
          c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1260.8,976.1,1258.7,974,1254.8,974z M1284,974c-2.1,0-3.9,0.9-5,2.5
          v-2h-4.5v24h4.6V991c1.1,1.3,2.7,1.9,4.6,1.9c4.7,0,7.5-3.5,7.5-9.5C1291.3,977.5,1288.6,974,1284,974z M1282.7,989
          c-1.6,0-2.8-0.8-3.5-2.6v-5.9c0.7-1.8,1.9-2.6,3.5-2.6c2.4,0,3.7,1.9,3.7,5.5C1286.5,987,1285.1,989,1282.7,989z M1310.6,988.5
          c-0.3,0.2-0.7,0.3-0.9,0.3c-0.5,0-0.8-0.3-0.8-1.3v-6.9c0-4.3-2.2-6.5-6.9-6.5c-4.1,0-7.1,1.8-7.5,5.2l4.2,1.1
          c0.1-1.8,1.3-2.8,3.2-2.8c1.6,0,2.5,0.9,2.5,2.7v0.8l-3.9,0.8c-4.6,0.9-6.2,2.9-6.2,6c0,2.8,2.3,5,5.7,5c2,0,3.7-0.8,4.8-2.5
          c0.7,1.8,1.8,2.4,3.4,2.4c1.3,0,2.4-0.4,3.3-1.3L1310.6,988.5z M1301.2,989.1c-1.4,0-2.3-0.6-2.3-2c0-1.2,0.6-2.1,2.9-2.6l2.5-0.6
          v3.1C1303.8,988.4,1302.7,989.1,1301.2,989.1z M1323.4,974c-2.2,0-3.8,1.4-4.5,3.6v-3.1h-4.4v17.8h4.6v-10.7
          c0.5-2.2,1.8-3.1,3.6-3.1c0.8,0,1.6,0.2,2.2,0.5l1.2-4.5C1325.5,974.2,1324.6,974,1323.4,974z M1339.2,987.8
          c-0.8,0.5-1.5,0.7-2.2,0.7c-1.1,0-1.7-0.8-1.7-2.2v-7.9h3.9v-3.9h-3.9v-4.4h-4c0,4.3-0.1,4.4-3.9,4.4v3.9h3.3v8.8
          c0,3.6,1.9,5.7,5,5.7c1.8,0,3.3-0.5,4.5-1.4L1339.2,987.8z M1358.3,982.5c0-4.7-2.6-8.5-8.1-8.5c-5.6,0-8.2,4-8.2,9.4
          c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6c-2.4,0-3.9-1.8-3.9-4.8h11.8
          C1358.2,984.1,1358.3,983.8,1358.3,982.5z M1350.1,977.3c2.3,0,3.5,1.5,3.6,4.1h-7.3C1346.6,978.7,1348.1,977.3,1350.1,977.3z
           M1371.3,974c-2.2,0-3.8,1.4-4.5,3.6v-3.1h-4.4v17.8h4.6v-10.7c0.5-2.2,1.8-3.1,3.6-3.1c0.8,0,1.6,0.2,2.2,0.5l1.2-4.5
          C1373.4,974.2,1372.5,974,1371.3,974z M1386.4,974c-2.4,0-4.3,1-5.2,2.7v-2.2h-4.4v17.8h4.6v-12.1c0.8-1.6,2-2.4,3.3-2.4
          c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1392.4,976.1,1390.3,974,1386.4,974z M1404,992.9c4.1,0,7.1-2.2,7.1-5.9
          c0-2.9-1.4-4.6-4.5-5.2l-3.3-0.7c-1.6-0.3-2.3-0.9-2.3-1.8c0-1,0.9-1.6,2.4-1.6c1.7,0,2.8,0.7,3.1,2.1l4.4-1.2
          c-0.7-3-3.2-4.5-7.5-4.5c-4.2,0-6.9,2.1-6.9,5.5c0,2.9,1.8,4.8,5.3,5.5l3,0.6c1.3,0.3,1.8,0.8,1.8,1.8c0,1.2-0.9,1.8-2.6,1.8
          c-1.7,0-2.9-0.8-3.3-2.3l-4.7,1.3C1396.9,991.4,1399.6,992.9,1404,992.9z M1424.7,974c-2.3,0-4.1,0.9-5,2.5v-10.2h-4.6v26.1h4.6
          v-12.1c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1430.7,976.1,1428.6,974,1424.7,974z M1435.9,971.2h5v-4.8h-5
          V971.2z M1436,992.4h4.6v-17.8h-4.6V992.4z M1455.7,974c-2.1,0-3.9,0.9-5,2.5v-2h-4.5v24h4.6V991c1.1,1.3,2.7,1.9,4.6,1.9
          c4.7,0,7.5-3.5,7.5-9.5C1462.9,977.5,1460.3,974,1455.7,974z M1454.3,989c-1.6,0-2.8-0.8-3.5-2.6v-5.9c0.7-1.8,1.9-2.6,3.5-2.6
          c2.4,0,3.7,1.9,3.7,5.5C1458.1,987,1456.8,989,1454.3,989z M1494,974.6l-2.8,12.1l-2.9-12.1h-4.1l-3.1,11.9l-2.6-11.9h-5l4.9,17.8
          h4.1l3.1-11.5l3.1,11.5h4.2l4.8-17.8H1494z M1501.4,971.2h5v-4.8h-5V971.2z M1501.5,992.4h4.6v-17.8h-4.6V992.4z M1521.1,987.8
          c-0.8,0.5-1.5,0.7-2.2,0.7c-1.1,0-1.7-0.8-1.7-2.2v-7.9h3.9v-3.9h-3.9v-4.4h-4c0,4.3-0.1,4.4-3.9,4.4v3.9h3.3v8.8
          c0,3.6,1.9,5.7,5,5.7c1.8,0,3.3-0.5,4.5-1.4L1521.1,987.8z M1535.3,974c-2.3,0-4.1,0.9-5,2.5v-10.2h-4.6v26.1h4.6v-12.1
          c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1541.3,976.1,1539.2,974,1535.3,974z M1547.9,980.5h5.2v-5.1h-5.2
          V980.5z M1547.9,992.4h5.2v-5.1h-5.2V992.4z M1062.1,1012.5h-6.7v25.3h6.7c8,0,12.1-4.5,12.1-12.7
          C1074.3,1017,1070.2,1012.5,1062.1,1012.5z M1062.4,1034.1h-2.2v-17.8h2.2c4.4,0,6.8,3.2,6.8,8.9
          C1069.2,1030.9,1066.9,1034.1,1062.4,1034.1z M1078.8,1016.7h5v-4.8h-5V1016.7z M1078.9,1037.9h4.6V1020h-4.6V1037.9z
           M1095.5,1038.4c4.1,0,7.1-2.2,7.1-5.9c0-2.9-1.4-4.6-4.5-5.2l-3.3-0.7c-1.6-0.3-2.3-0.9-2.3-1.8c0-1,0.9-1.6,2.4-1.6
          c1.7,0,2.8,0.7,3.1,2.1l4.4-1.2c-0.7-3-3.2-4.5-7.5-4.5c-4.2,0-6.9,2.1-6.9,5.5c0,2.9,1.9,4.8,5.3,5.5l3,0.6
          c1.3,0.3,1.8,0.8,1.8,1.8c0,1.2-0.9,1.8-2.6,1.8c-1.7,0-2.9-0.8-3.3-2.3l-4.7,1.3C1088.4,1036.9,1091.1,1038.4,1095.5,1038.4z
           M1114.2,1038.4c4.4,0,6.9-2.1,7.6-5.5l-4.4-1.2c-0.3,2.1-1.2,3.1-3,3.1c-2.4,0-3.7-1.9-3.7-5.8c0-3.9,1.4-5.8,3.7-5.8
          c1.8,0,2.7,1,3,3.1l4.5-1.2c-0.7-3.5-3.1-5.5-7.5-5.5c-5.1,0-8.5,3.3-8.5,9.4C1105.8,1035,1109.2,1038.4,1114.2,1038.4z
           M1132.7,1038.4c5.3,0,8.8-3.5,8.8-9.5c0-5.9-3.5-9.4-8.8-9.4c-5.2,0-8.8,3.5-8.8,9.4C1124,1034.9,1127.5,1038.4,1132.7,1038.4z
           M1132.7,1034.8c-2.5,0-3.9-2.1-3.9-5.9c0-3.7,1.4-5.8,3.9-5.8c2.5,0,3.9,2.1,3.9,5.8C1136.7,1032.7,1135.3,1034.8,1132.7,1034.8z
           M1156.4,1020.1l-4.6,12.8l-4.5-12.8h-5l6.8,17.8h4.5l6.8-17.8H1156.4z M1177.8,1028c0-4.7-2.6-8.5-8.1-8.5c-5.6,0-8.2,4-8.2,9.4
          c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6c-2.4,0-3.9-1.8-3.9-4.8h11.8
          C1177.8,1029.6,1177.8,1029.3,1177.8,1028z M1169.7,1022.8c2.3,0,3.5,1.5,3.6,4.1h-7.3C1166.2,1024.2,1167.7,1022.8,1169.7,1022.8z
           M1190.9,1019.5c-2.2,0-3.8,1.4-4.5,3.6v-3.1h-4.4v17.8h4.6v-10.7c0.5-2.2,1.9-3.1,3.6-3.1c0.8,0,1.6,0.2,2.2,0.5l1.2-4.5
          C1192.9,1019.7,1192,1019.5,1190.9,1019.5z M1208.3,1020.1l-4.4,11.6l-4.4-11.6h-4.9l7,17.6l-0.3,0.8c-0.7,1.8-1.6,2.2-2.6,2.2
          c-0.8,0-1.4-0.2-2-0.5l-1,3.8c0.9,0.5,2.1,0.7,3.2,0.7c2.8,0,4.4-1.4,5.3-3.7l8.3-20.8H1208.3z M1238.7,1016.3v-3.8h-14.8v25.3
          h14.8v-3.8h-10.1v-7.6h8v-3.8h-8v-6.4H1238.7z M1253.3,1011.8v10c-0.9-1.4-2.8-2.3-5-2.3c-4.7,0-7.4,3.4-7.4,9.4
          c0,6,2.8,9.5,7.7,9.5c2.4,0,4.1-0.9,5.3-2.6l0.5,2h3.6v-26.1H1253.3z M1249.6,1034.5c-2.5,0-3.8-2-3.8-5.6c0-3.5,1.3-5.5,3.8-5.5
          c1.8,0,3,0.8,3.8,2.5v6C1252.6,1033.7,1251.4,1034.5,1249.6,1034.5z M1274.1,1020.1v12.1c-0.8,1.6-2,2.4-3.3,2.4
          c-2,0-3.1-1.1-3.1-3.6v-10.9h-4.6v12.1c0,4.2,2.1,6.3,6,6.3c2.4,0,4.4-1,5.2-2.8v2.3h4.4v-17.8H1274.1z M1291.2,1038.4
          c4.4,0,6.9-2.1,7.6-5.5l-4.5-1.2c-0.3,2.1-1.2,3.1-3,3.1c-2.3,0-3.7-1.9-3.7-5.8c0-3.9,1.4-5.8,3.7-5.8c1.8,0,2.7,1,3,3.1l4.5-1.2
          c-0.7-3.5-3.1-5.5-7.5-5.5c-5.1,0-8.5,3.3-8.5,9.4C1282.8,1035,1286.2,1038.4,1291.2,1038.4z M1317.6,1034
          c-0.3,0.2-0.7,0.3-0.9,0.3c-0.5,0-0.8-0.3-0.8-1.3v-6.9c0-4.3-2.2-6.5-6.9-6.5c-4.1,0-7.1,1.8-7.5,5.2l4.2,1.1
          c0.1-1.8,1.3-2.8,3.2-2.8c1.6,0,2.5,0.9,2.5,2.7v0.8l-3.9,0.8c-4.6,0.9-6.2,2.9-6.2,6c0,2.8,2.3,5,5.7,5c2,0,3.7-0.8,4.8-2.5
          c0.7,1.8,1.8,2.4,3.4,2.4c1.3,0,2.4-0.4,3.3-1.3L1317.6,1034z M1308.1,1034.6c-1.4,0-2.3-0.6-2.3-2c0-1.2,0.6-2.1,2.9-2.6l2.5-0.6
          v3.1C1310.7,1033.8,1309.6,1034.6,1308.1,1034.6z M1330.6,1033.3c-0.8,0.5-1.5,0.7-2.2,0.7c-1.1,0-1.7-0.8-1.7-2.2v-7.9h3.9v-3.9
          h-3.9v-4.4h-4c0,4.3-0.1,4.4-3.9,4.4v3.9h3.3v8.8c0,3.6,1.9,5.7,5,5.7c1.8,0,3.3-0.5,4.5-1.4L1330.6,1033.3z M1335.1,1016.7h5v-4.8
          h-5V1016.7z M1335.2,1037.9h4.6V1020h-4.6V1037.9z M1352.8,1038.4c5.3,0,8.8-3.5,8.8-9.5c0-5.9-3.5-9.4-8.8-9.4
          c-5.3,0-8.8,3.5-8.8,9.4C1344,1034.9,1347.5,1038.4,1352.8,1038.4z M1352.8,1034.8c-2.5,0-3.9-2.1-3.9-5.9c0-3.7,1.4-5.8,3.9-5.8
          c2.5,0,3.9,2.1,3.9,5.8C1356.7,1032.7,1355.3,1034.8,1352.8,1034.8z M1375.5,1019.5c-2.4,0-4.3,1-5.2,2.7v-2.2h-4.4v17.8h4.6v-12.1
          c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1381.5,1021.6,1379.3,1019.5,1375.5,1019.5z M1389.1,1042.9
          c2.2-0.4,4.1-1.5,4.1-4.8v-5.4h-5.2v5.1h2.7v0.7c0,1.4-0.5,1.9-2.1,2.3L1389.1,1042.9z M1420.7,1024.5c3-0.6,4.8-2.9,4.8-5.9
          c0-3.9-2.7-6.2-7.6-6.2h-9.3v25.3h8.8c5.9,0,9.1-2.6,9.1-7.2C1426.6,1027.2,1424.6,1025,1420.7,1024.5z M1420.7,1019.5
          c0,2.2-1.4,3.5-3.9,3.5h-3.4v-6.7h3.5C1419.4,1016.3,1420.7,1017.5,1420.7,1019.5z M1417.5,1034.1h-4.1v-7.5h3.9
          c2.9,0,4.4,1.3,4.4,3.7C1421.8,1032.7,1420.2,1034.1,1417.5,1034.1z M1445.2,1037.9h5.1l-8.3-25.3h-5.6l-8.3,25.3h4.7l1.9-6.4h8.6
          L1445.2,1037.9z M1435.9,1027.6l3.1-10.5l3.1,10.5H1435.9z M1465.6,1024.5c3-0.6,4.8-2.9,4.8-5.9c0-3.9-2.7-6.2-7.6-6.2h-9.3v25.3
          h8.8c5.9,0,9.1-2.6,9.1-7.2C1471.5,1027.2,1469.6,1025,1465.6,1024.5z M1465.6,1019.5c0,2.2-1.4,3.5-3.9,3.5h-3.4v-6.7h3.5
          C1464.3,1016.3,1465.6,1017.5,1465.6,1019.5z M1462.4,1034.1h-4.1v-7.5h3.9c2.9,0,4.4,1.3,4.4,3.7
          C1466.7,1032.7,1465.1,1034.1,1462.4,1034.1z M1491,1016.3v-3.8h-14.8v25.3h14.8v-3.8h-10.1v-7.6h8v-3.8h-8v-6.4H1491z
           M1504.4,1038.4c5.8,0,9.2-3,9.8-7.4l-5-1.3c-0.5,3.2-2,4.9-4.8,4.9c-3.7,0-5.6-3.4-5.6-9.4c0-5.9,1.9-9.4,5.6-9.4
          c2.8,0,4.3,1.7,4.8,5l4.9-1.3c-0.7-4.5-4-7.5-9.8-7.5c-6.8,0-10.6,5-10.6,13.2C1493.8,1033.4,1497.6,1038.4,1504.4,1038.4z
           M1519.7,1042.9c2.2-0.4,4.1-1.5,4.1-4.8v-5.4h-5.2v5.1h2.7v0.7c0,1.4-0.5,1.9-2.1,2.3L1519.7,1042.9z M1554.4,1034
          c-0.3,0.2-0.7,0.3-0.9,0.3c-0.5,0-0.8-0.3-0.8-1.3v-6.9c0-4.3-2.2-6.5-6.9-6.5c-4.1,0-7.1,1.8-7.5,5.2l4.2,1.1
          c0.1-1.8,1.3-2.8,3.2-2.8c1.6,0,2.5,0.9,2.5,2.7v0.8l-3.9,0.8c-4.6,0.9-6.2,2.9-6.2,6c0,2.8,2.3,5,5.7,5c2,0,3.7-0.8,4.8-2.5
          c0.7,1.8,1.8,2.4,3.4,2.4c1.3,0,2.4-0.4,3.3-1.3L1554.4,1034z M1544.9,1034.6c-1.4,0-2.3-0.6-2.3-2c0-1.2,0.6-2.1,2.9-2.6l2.5-0.6
          v3.1C1547.5,1033.8,1546.4,1034.6,1544.9,1034.6z M1567.9,1019.5c-2.4,0-4.3,1-5.2,2.7v-2.2h-4.4v17.8h4.6v-12.1
          c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1573.9,1021.6,1571.7,1019.5,1567.9,1019.5z M1590.1,1011.8v10
          c-0.9-1.4-2.8-2.3-5-2.3c-4.7,0-7.4,3.4-7.4,9.4c0,6,2.8,9.5,7.7,9.5c2.3,0,4.1-0.9,5.2-2.6l0.5,2h3.6v-26.1H1590.1z
           M1586.4,1034.5c-2.5,0-3.8-2-3.8-5.6c0-3.5,1.3-5.5,3.8-5.5c1.8,0,3,0.8,3.8,2.5v6C1589.4,1033.7,1588.2,1034.5,1586.4,1034.5z
           M1608.9,1037.9h4.7v-25.3h-4.7V1037.9z M1629.6,1033.8h-5.6c-0.9,0-1.4-0.4-1.4-1c0-0.5,0.2-0.9,0.9-1.1c0.6,0.1,1.3,0.2,2,0.2
          c4.2,0,7.2-2.6,7.2-6.2c0-0.6-0.1-1.2-0.3-1.7h2.1v-3.9h-6c-0.9-0.4-2-0.5-3.1-0.5c-4.2,0-7.2,2.6-7.2,6.2c0,2.2,1.1,4.1,2.9,5.1
          c-1.5,0.7-2.3,1.7-2.3,3.1c0,1.3,0.7,2.4,1.7,3c-1.6,0.8-2.3,1.8-2.3,3.3c0,2.6,2.9,4.3,7.6,4.3c5.6,0,9-2.4,9-6.2
          C1634.8,1035.5,1633,1033.8,1629.6,1033.8z M1625.4,1022.6c1.8,0,2.9,1.2,2.9,3.1c0,1.9-1.1,3.1-2.9,3.1c-1.7,0-2.9-1.2-2.9-3.1
          C1622.6,1023.8,1623.6,1022.6,1625.4,1022.6z M1626.1,1041.5c-2.5,0-4.1-0.9-4.1-2.2c0-0.6,0.3-1.2,0.8-1.6c0.2,0,0.4,0,0.6,0h5.2
          c1.8,0,2.4,0.5,2.4,1.4C1630.9,1040.6,1629.1,1041.5,1626.1,1041.5z M1648,1019.5c-2.4,0-4.3,1-5.2,2.7v-2.2h-4.4v17.8h4.6v-12.1
          c0.8-1.6,2-2.4,3.3-2.4c2.1,0,3.1,1,3.1,3.6v10.9h4.6v-12.1C1654,1021.6,1651.9,1019.5,1648,1019.5z M1659.2,1016.7h5v-4.8h-5
          V1016.7z M1659.3,1037.9h4.6V1020h-4.6V1037.9z M1679,1033.3c-0.8,0.5-1.5,0.7-2.2,0.7c-1.1,0-1.7-0.8-1.7-2.2v-7.9h3.9v-3.9h-3.9
          v-4.4h-4c0,4.3-0.1,4.4-3.9,4.4v3.9h3.3v8.8c0,3.6,1.9,5.7,5,5.7c1.8,0,3.3-0.5,4.5-1.4L1679,1033.3z M1698.1,1028
          c0-4.7-2.6-8.5-8.1-8.5c-5.6,0-8.2,4-8.2,9.4c0,5.9,3.2,9.4,8.5,9.4c4.2,0,6.7-1.8,7.6-5.1l-4.1-1c-0.6,1.8-1.8,2.6-3.6,2.6
          c-2.4,0-3.9-1.8-3.9-4.8h11.8C1698,1029.6,1698.1,1029.3,1698.1,1028z M1689.9,1022.8c2.3,0,3.5,1.5,3.6,4.1h-7.3
          C1686.4,1024.2,1687.9,1022.8,1689.9,1022.8z M1713.2,1011.8v10c-0.9-1.4-2.8-2.3-5-2.3c-4.7,0-7.4,3.4-7.4,9.4
          c0,6,2.8,9.5,7.7,9.5c2.4,0,4.1-0.9,5.3-2.6l0.5,2h3.6v-26.1H1713.2z M1709.4,1034.5c-2.5,0-3.8-2-3.8-5.6c0-3.5,1.3-5.5,3.8-5.5
          c1.8,0,3,0.8,3.8,2.5v6C1712.4,1033.7,1711.3,1034.5,1709.4,1034.5z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ActivityBumper',
  data() {
    return {
      timeout: null,
    };
  },
  props: {
    delay: {
      type: Number,
      default: 4000,
    },
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.$emit('on-completed', this.nextComponent);
    }, this.delay);
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
};
</script>

<style lang="stylus" scoped>

.st0
  clip-path url(#SVGID_00000035493147344336573110000005879155052840445333_)

.st1
  clip-path url(#SVGID_00000004517422416127610640000002380692271897631405_);

.st2
  fill #54585C

.st3
  clip-path url(#SVGID_00000161600343806653367650000013393402473384478389_)

.st4
  fill #F19621

.st5
  fill #470A68

.st6
  fill #FFFFFF

.activity-bumper-wrap
  background-color #FFFFFF

  .fadeIn
    animation-direction normal
    animation-timing-function linear

  .fadeInUp
    animation-delay 0.5s
    animation-timing-function: ease;
    animation-duration 1.5s
</style>
